import Backbone from 'backbone';
import $ from 'jquery';
import React from 'react';

import * as analytics from 'analytics/Analytics';
import DataRecoveryModalClass from 'notebook/store/data-recovery/DataRecoveryModal';
// @ts-expect-error
import drafts from 'notebook/store/data-recovery/Drafts';
import notifications from 'notifications';
import * as LegacyModalContainer from 'ui-library/LegacyModalContainer';
import ifCreateFromHash from 'util/ifCreateFromHash';

function dismiss(): void {
  const localDrafts = drafts.getLocalDrafts();
  for (const draftId of Object.keys(localDrafts)) {
    const draft = localDrafts[draftId];
    if (drafts.isRecoverable(draft)) {
      localDrafts[draftId].dismissed = true;
    }
  }
  drafts.setLocalDrafts(localDrafts);
}

function checkHash(): void {
  ifCreateFromHash(drafts.RECOVERY_HASH, () => {
    analytics.track('data_recovery', 'open_modal');
    LegacyModalContainer.open(
      DataRecoveryModalClass,
      <DataRecoveryModalClass
        onRequestClose={function () {
          LegacyModalContainer.close(DataRecoveryModalClass);
        }}
        onDismiss={dismiss}
      />
    );
  });
}

class DataRecoveryHashView extends Backbone.View<Backbone.Model> {
  override render(): this {
    if (drafts.recoverableDataExist()) {
      analytics.track('data_recovery', 'see_prompt');
      notifications.warn(
        <div>
          We recovered unsaved changes to your files. <a href={drafts.RECOVERY_HASH}>Click here</a> to recover
          this data.
        </div>,
        {duration: 0, id: drafts.RECOVERY_ID, onClose: dismiss}
      );
    }

    $(window).on('hashchange', checkHash);
    checkHash();
    return this;
  }
}

export default DataRecoveryHashView;
